import React, {useState} from 'react';
import {TabPanel, TabView} from "primereact/tabview";
import { T } from 'services/lang/LanguageService';

import AlertFan from "./AlertFan";
import Silences from "./Silences";

const AlertTabMain = ({topicTags, itemTags, hiddenTopicTags}) => {
    const [tab, setTab] = useState(0)

    const [tags, setTags] = useState<{ topics?: Array<string>, items?: Array<string> }>()

    return <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
        <TabPanel header={T("word.alerts")}>
            <AlertFan setTab={setTab} setTags={setTags} topicTags={topicTags} itemTags={itemTags} hiddenTopicTags={hiddenTopicTags}/>
        </TabPanel>
        <TabPanel header={T("word.alert-fan.silences")}>
            <Silences setTab={setTab} tags={tags} setTags={setTags} />
        </TabPanel>
    </TabView>
};

export default AlertTabMain;